import { create } from 'zustand';
import { messages } from './messages';

export const languages = { fr: 'Français', en: 'English', it: 'Italiano', es: 'Español' };
export const languageKey = 'glassorder-language';
const isSupported = (language) => Object.prototype.hasOwnProperty.call(languages, language);
export function detectLanguage() {
  try {
    const saved = localStorage.getItem(languageKey);
    if (isSupported(saved)) return saved;
  } catch (_) {}
  for (const candidate of (typeof navigator === 'undefined' ? [] : navigator.languages || [navigator.language])) {
    const code = String(candidate || '').toLowerCase().split('-')[0];
    if (isSupported(code)) return code;
  }
  return 'fr';
}
export const useLanguage = create((set) => ({
  language: detectLanguage(),
  setLanguage: (language) => {
    if (!isSupported(language)) return;
    try { localStorage.setItem(languageKey, language); } catch (_) {}
    set({ language });
  },
}));
export function t(source, values = {}) {
  const language = useLanguage.getState().language;
  const index = ['en', 'it', 'es'].indexOf(language);
  const message = index < 0 ? source : messages[source]?.[index] || source;
  return message.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);
}
export const formatMoney = (amount) => new Intl.NumberFormat(useLanguage.getState().language, { style: 'currency', currency: 'EUR' }).format(Number(amount));
export const locale = () => ({ fr: 'fr-FR', en: 'en-GB', it: 'it-IT', es: 'es-ES' }[useLanguage.getState().language]);

export function translateError(detail, fallback = 'Une erreur est survenue. Veuillez réessayer.') {
  const message = typeof detail === 'string' ? detail : detail?.message;
  const aliases = {
    'Table not found': "Cette table n'existe pas",
    'Table non trouvee. Verifiez le numero.': "Cette table n'existe pas",
    'Order not found': 'Commande introuvable',
    'Establishment not found': 'Établissement introuvable',
    'Le paiement en espèces est indisponible': "Le paiement en espèces n'est pas disponible",
  };
  if (aliases[message]) return t(aliases[message]);
  if (messages[message]) return t(message);
  const source = Object.keys(messages).find(key => messages[key].includes(message));
  if (source) return t(source);
  const minimum = message?.match(/^Minimum d'achat requis: ([\d.]+)€/);
  if (minimum) return t("Minimum d'achat requis : {amount}", { amount: formatMoney(minimum[1]) });
  return t(fallback);
}
